import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const categories = [
    { name: 'iPhone Cases', slug: 'iphone-cases' },
    { name: 'Samsung Cases', slug: 'samsung-cases' },
    { name: 'Accessories', slug: 'accessories' },
    { name: 'Custom Design', slug: 'custom-design', isSpecial: true, isNew: true },
    { name: 'Lounge', slug: 'lounge', isSpecial: true },
    { name: 'New Arrivals', slug: 'new-arrivals' },
    { name: 'Sale', slug: 'sale', isSale: true }
  ];

  return (
    <nav className="bg-white border-b border-stone-200" data-testid="navigation">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center">
          <div className="flex items-center gap-8 overflow-x-auto py-4">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={category.isSpecial ? `/${category.slug}` : `/shop/${category.slug}`}
                className={`font-medium text-[15px] whitespace-nowrap transition-colors flex items-center gap-1 ${
                  category.isNew
                    ? 'text-red-600 hover:text-red-700 font-semibold'
                    : category.isSpecial 
                    ? 'text-amber-700 hover:text-amber-900 font-semibold' 
                    : category.isSale
                    ? 'text-red-600 hover:text-red-700 font-semibold'
                    : 'text-stone-700 hover:text-amber-600'
                }`}
                data-testid={`nav-${category.slug}`}
              >
                {category.name}
                {category.isNew && (
                  <span className="text-[10px] bg-red-600 text-white px-1.5 py-0.5 font-bold">NEW</span>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
